import { catchError } from './common';
import axios from 'axios';

export const logFeedback = async (
  runId: string,
  feedbackType: string,
  agentName: string | null = null
): Promise<any> => {
  let retObj: any;
  try {
    const response = await axios.post(`${import.meta.env.VITE_API_DOMAIN}v2/ai/feedback/submit`, {
      run_id: runId,
      key: feedbackType,
      score: true,
      value: 1,
      ...(agentName != null && { agent_name: 'Image Generator' }),
    });
    return response?.data?.data;
  } catch (e: any) {
    console.error(e);
    catchError(e);
    //return not used, keep typescript happy
    return retObj;
  }
};

export const logCommentFeedback = async (
  runId: string,
  feedbackType: string,
  comment: string,
  feedbackId: string | null = null
): Promise<any> => {
  let retObj: any;
  try {
    await axios.post(`${import.meta.env.VITE_API_DOMAIN}v2/ai/feedback/comment`, {
      run_id: runId,
      key: feedbackType,
      score: true,
      value: 1,
      comment,
      ...(feedbackId != null && { feedback_id: feedbackId }),
    });
    return retObj;
  } catch (e: any) {
    console.error(e);
    catchError(e);
  }
};
